import { render, staticRenderFns } from "./shopLeavel.vue?vue&type=template&id=c3fb50e8&scoped=true"
import script from "./shopLeavel.vue?vue&type=script&lang=js"
export * from "./shopLeavel.vue?vue&type=script&lang=js"
import style0 from "./shopLeavel.vue?vue&type=style&index=0&id=c3fb50e8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3fb50e8",
  null
  
)

export default component.exports